import React from 'react';
import PropTypes from 'prop-types';
import { FormattedRelativeTime } from 'react-intl';
import { selectUnit } from '@formatjs/intl-utils';
import { parseISODate } from '../../containers/VisitsAvailability/utils';

function SmartFormattedRelativeTime({ value }) {
  return <FormattedRelativeTime {...selectUnit(parseISODate(value))} numeric="auto" />;
}
SmartFormattedRelativeTime.propTypes = {
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.instanceOf(Date)]).isRequired,
};

export default SmartFormattedRelativeTime;
